import Vue from 'vue';
import axios from 'axios';
import '../filters';
import moment from 'moment';
import users from '../users';
import themes from 'devextreme/ui/themes';

import {
  DxDataGrid,
  DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxColumnChooser,
  DxExport,
  DxSelection,
  DxPaging,
  DxSorting,
  DxHeaderFilter,
  DxFilterPanel,
  DxFilterRow,
  DxFilterBuilderPopup,
  DxScrolling,
  DxSummary,
  DxStateStoring,
  DxGroupItem,
  DxTotalItem,
  DxEditing,
  DxPager
} from 'devextreme-vue/data-grid';
import { DashboardControl, DashboardPanelExtension } from 'devexpress-dashboard';
import * as utils from '../utils';

export default {
  name: 'Dashboards',
  mixins: [users],
  components: {
    DxColumn,
    DxGroupPanel,
    DxGrouping,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxColumnChooser,
    DxExport,
    DxSelection,
    DxHeaderFilter,
    DxFilterPanel,
    DxFilterRow,
    DxFilterBuilderPopup,
    DxScrolling,
    DxSummary,
    DxStateStoring,
    DxGroupItem,
    DxTotalItem,
    DxEditing,
    DxDataGrid,
    DxPager
  },
  data: function () {
    return {
      dashboardControl: null,
      theme: 'light',
      componentId: 'dashBoard',
      message: '',
      dashboardLinks: [],
      masterDashboards: [],
      propertyPreference: {
        propertyCode: '',
        accountCode: '',
        accountCount: 0,
        address: '',
        bShowDialog: false,
        profileAccount: '',
        bClicked: false
      },
      dashboardId: '',
      forcePanelVisible: false,
      dashboardModuleId: 10000
    };
  },
  computed: {
    languageLocale: function () {
      return this.$i18n.locale;
    }
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      this.initRenderDashBoard();
    });

    //this.dashboardControl = new DashboardControl(document.getElementById(this.componentId), {
    //  endpoint: document.location.origin + "/api/dashboard",
    //  workingMode: "ViewerOnly",
    //  allowMaximizeItems: true,
    //  onDashboardEndUpdate: this.applyParameters,
    //  dashboardId: this.dashboardId
    //});
    //this.dashboardControl.registerExtension(new DashboardPanelExtension(this.dashboardControl));
    //this.dashboardControl.render();
  },
  beforeDestroy() {
    this.dashboardControl.dispose();
  },
  created() {
    if (
      (this.$store.getters.getUserProfile &&
        (this.$store.getters.getUserProfile.isFieldWorker || !this.$store.getters.getUserProfile.managementDashboards)) ||
      (this.$store.getters.getSettings && !this.$store.getters.getSettings.allowDashboardsEmployee)
    ) {
      this.$router.push('/employeeHome');
      return;
    }

    this.getPropertyLocalStorage();
    this.$root.$on('property_account_updated', this.getPropertyLocalStorage);
  },
  methods: {
    initRenderDashBoard() {
      axios.get('/Account/SetLayoutType?LayoutType=' + (utils.isMobileDevice() ? 1 : 0)).finally(() => this.renderDashboard());
    },
    togglePanel(visible) {
      var cntrl = this.dashboardControl;
      this.forcePanelVisible = visible;
      if (visible)
        cntrl.extensions[6].hidePanelAsync({}).done(function (e) {
          cntrl.surfaceLeft(e.surfaceLeft);
        });
      else
        cntrl.extensions[6].showPanelAsync({}).done(function (e) {
          cntrl.surfaceLeft(e.surfaceLeft);
        });
    },
    renderDashboard() {
      this.dashboardControl = new DashboardControl(document.getElementById(this.componentId), {
        endpoint: document.location.origin + '/api/dashboard/' + this.dashboardModuleId,
        workingMode: 'ViewerOnly', //'Designer' | 'Viewer' | 'ViewerOnly'
        allowMaximizeItems: true,
        onDashboardEndUpdate: this.applyParameters,
        dashboardId: this.dashboardId,
        extensions: {
          'viewer-api': {
            onItemWidgetUpdated: (e) => {
              this.addLegendToPieChart(e.getWidget());
            },
            onItemWidgetCreated: (e) => {
              this.addLegendToPieChart(e.getWidget());
            }
          }
        }
      });
      this.dashboardControl.registerExtension(new DashboardPanelExtension(this.dashboardControl));
      this.dashboardControl.render();
      if (this.dashboardControl)
        this.dashboardControl.requestDashboardList().done(function (e) {
          //e.forEach(function (dashboardInfo) {
          //  console.log(dashboardInfo);
          //});
        });
    },
    addLegendToPieChart(e) {
      var pie = e[0];

      if (pie != undefined) {
        if (pie.NAME == 'dxPieChart') {
          pie.option({
            legend: {
              visible: true,
              border: {
                visible: true
              }
            }
          });
        }
      }
    },
    switchThemes(th): void {
      //let theme = window.localStorage.getItem("dx-theme") || "light";
      //if (theme === "light")
      //  return;
      document.getElementById('themeAnalytics').setAttribute('href', 'assets/css/analytics/dx-analytics.' + th + '.css');
      document.getElementById('themeDashboard').setAttribute('href', 'assets/css/dashboard/dx-dashboard.' + th + '.css');
      themes.current('generic.' + th);
      let db = this.dashboardControl;
      themes.ready(function () {
        db.render();
      });
    },
    getPropertyLocalStorage() {
      var propertyData = this.$localStorage.get('_property');
      if (propertyData && propertyData !== 'null') this.propertyPreference = JSON.parse(propertyData);
      this.applyParameters();
      //if (this.propertyPreference.profileAccount !== this.propertyPreference.accountCode) {
      //  this.applyParameters();
      //}
    },
    applyParameters(e) {
      if (!this.propertyPreference || !this.propertyPreference.accountCode) return;
      var state = '{"Parameters":{"LinkCustkeyPar":' + this.propertyPreference.accountCode + '}}';
      if (this.dashboardControl) this.dashboardControl.setDashboardState(state);
      if (this.dashboardControl) console.log(this.dashboardControl.getDashboardState()); // console.log returns existing parameter newly set value
    },
    setDashboardParameters(parameter) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios
        .post('/DefaultDashboard/SetDashboardParameters', parameter)
        .then((response) => {
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    getDashboardLinks(dashboardId) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios
        .post('/DefaultDashboard/GetDashboardLinks?dashboardId' + '=' + dashboardId)
        .then((response) => {
          this.dashboardLinks = response.data.items;
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    getMasterDashboards() {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios
        .post('/DefaultDashboard/GetMasterDashboards', { Type: 3 })
        .then((response) => {
          this.masterDashboards = response.data;
          this.prepareTreeData();
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    }
  }
};
